<template>
	<div class="grid">
    <!-- <div class="card">
    <h2 class="title"> {{ pageTitle }}</h2>
   </div> -->
    <Loader v-if="loader" />


     <!-- <div class="card col-12">
      <h2>Benvenuto</h2>
      <small>Hai effettuato l'accesso come: <span class="email">{{currentUser.user[0].email}}</span></small>
    </div>  -->

    <div class="card col-12">
      <h2>DASHBOARD</h2>
      <small>Riepilogo forniture, consumi e fatturazione</small>
    </div> 

    <!--
    <div class="col-12">
      <div class="flex justify-content-end">
          <router-link to="/info-ciclo">
            <Button
              label="Info Ciclo" 
              class=""
              icon="pi pi-info-circle"
              iconPos="right"
            />
          </router-link>
      </div>
    </div> -->
    <div class="col-12 xl:col-6">
      <div class="card">
        <h5>Liquidità</h5>
        <div v-if=" banks.datasets[0].data.length > 0">
          <small>Euro</small>
          <Chart ref="chartRefBanks" type="bar" :data="banks" />
          <i class="pi pi-download" @click="exportChart($refs.chartRefBanks)"></i>
        </div>
        <div v-else>
          <SkeletonCustom />
        </div>
      </div>  
    </div>

    <div class="col-12 xl:col-6">
      <div class="card">
        <h5>Iva</h5>
        <div v-if="iva.datasets[0].data.length > 0">
          <small>Euro</small>
          <Chart ref="chartRefIva" type="bar" :data="iva" />
          <i class="pi pi-download" @click="exportChart($refs.chartRefIva)"></i>
        </div>
        <div v-else>
          <SkeletonCustom />
        </div>
      </div>  
    </div>


    <div class="col-12 xl:col-6">
      <div class="card">
        <h5>Numero Pod in fornitura</h5>
        <div v-if="pods.datasets[0].data.length > 0">
          <small>Pods</small>
          <Chart ref="chartRefPods" type="bar" :data="pods" />
          <i class="pi pi-download" @click="exportChart($refs.chartRefPods)"></i>
        </div>
        <div v-else>
          <SkeletonCustom />
        </div>
      </div>  
    </div>

    <div class="col-12 xl:col-6">
      <div class="card">
        <h5>Numero Pdr in fornitura</h5>
        <div v-if="pdrs.datasets[0].data.length > 0">
          <small>Pdrs</small>
          <Chart ref="chartRefPdrs" type="bar" :data="pdrs" />
          <i class="pi pi-download" @click="exportChart($refs.chartRefPdrs)"></i>
        </div>
        <div v-else>
          <SkeletonCustom />
        </div>
      </div>  
    </div>

    <div class="col-12 xl:col-6">
      <div class="card">
        <h5>Pma</h5>
        <div v-if="pma.datasets[0].data.length > 0">
          <small>PMA</small>
          <Chart ref="chartRefPma" type="bar" :data="pma" />
          <i class="pi pi-download" @click="exportChart($refs.chartRefPma)"></i>
        </div>
        <div v-else>
          <SkeletonCustom />
        </div>
      </div>  
    </div>


    <div class="col-12 xl:col-6">
      <div class="card">
        <h5>Consumo stimato annuo</h5>
        <div v-if="consumi.datasets[0].data.length > 0">
          <small>KWH</small>
          <Chart ref="chartRefConsumi" type="bar" :data="consumi" />
          <i class="pi pi-download" @click="exportChart($refs.chartRefConsumi)"></i>
        </div>
        <div v-else>
          <SkeletonCustom />
        </div>
      </div>  
    </div>

    <div class="col-12 xl:col-6">
      <div class="card">
        <h5>Pun EE</h5>
        <div v-if="pun.datasets[0].data.length > 0">
          <small>PUN EE</small>
          <Chart ref="chartRefPun" type="bar" :data="pun" />
          <i class="pi pi-download" @click="exportChart($refs.chartRefPun)"></i>
        </div>
        <div v-else>
          <SkeletonCustom />
        </div>
      </div>  
    </div>

    <div class="col-12 xl:col-6">
      <div class="card">
        <h5>Pun GAS</h5>
        <div v-if="punGas.datasets[0].data.length > 0">
          <small>PUN GAS</small>
          <Chart ref="chartRefPunGas" type="bar" :data="punGas" />
          <i class="pi pi-download" @click="exportChart($refs.chartRefPunGas)"></i>
        </div>
        <div v-else>
          <SkeletonCustom />
        </div>
      </div>  
    </div>

    <div class="col-12 xl:col-6">
      <div class="card">
        <h5 class="mb-0">Fatturato e Pagamenti</h5>
        <div class="mb-3"><small>VENDITA</small></div>
        <div v-if="fatturato_pagamenti.datasets[0].data.length > 0">
          <small>Euro</small>
          <Chart ref="chartRefFatturatoPagamenti" type="bar" :data="fatturato_pagamenti" />
          <i class="pi pi-download" @click="exportChart($refs.chartRefFatturatoPagamenti)"></i>
        </div>
        <div v-else>
          <SkeletonCustom />
        </div>
      </div>  
    </div>

    <div class="col-12 xl:col-6">
      <div class="card">
        <h5 class="mb-0">Fatturato e Pagamenti</h5>
        <div class="mb-3"><small>ACQUISTO</small></div>
        <div v-if="fatturato_pagamenti_acquisto.datasets[0].data.length > 0">
          <small>Euro</small>
          <Chart ref="chartRefFatturatoPagamentiAcquisto" type="bar" :data="fatturato_pagamenti_acquisto" />
          <i class="pi pi-download" @click="exportChart($refs.chartRefFatturatoPagamentiAcquisto)"></i>
        </div>
        <div v-else>
          <SkeletonCustom />
        </div>
      </div>  
    </div>
    
  
	</div>
</template>

<script>

import moment from 'moment'
import { useStore } from 'vuex'
import { getCurrentInstance, onMounted, ref } from 'vue';
import {useRouter} from 'vue-router';
import Service from '@/services/ask-pratiche/pratiche-dashboard'
import Loader from '@/components/Loader.vue'
import SkeletonCustom from '@/components/SkeletonCustom.vue'


export default {
    components: {
      Loader,
      SkeletonCustom,
    },
     setup() {
        const store = useStore()
        const router = useRouter() 
        const currentUser = ref(JSON.parse(atob(store.state.auth.user)))
        const loader = ref(false);
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        self.$http = self.appContext.config.globalProperties.$http
        const service = new Service(self.$http, self.$eventBus)
        const chartRefBanks = ref(null);
        const banks = ref({
            labels: [],
            datasets: [
                {
                    label: 'Saldo',
                    backgroundColor: '#81d126',
                    data: []
                },           
            ]
        });
        const chartRefFatturatoPagamenti = ref(null);
        const fatturato_pagamenti = ref({
            labels: [],
            datasets: [
                {
                    label: 'Fatturato',
                    backgroundColor: '#5f78f5',
                    data: []
                },
                {
                    label: 'Pagamenti',
                    backgroundColor: '#f55f5f',
                    data: []
                },           
            ]
        });
        const chartRefFatturatoPagamentiAcquisto = ref(null);
        const fatturato_pagamenti_acquisto = ref({
            labels: [],
            datasets: [
                {
                    label: 'Fatturato',
                    backgroundColor: '#5f78f5',
                    data: []
                },
                {
                    label: 'Pagamenti',
                    backgroundColor: '#f55f5f',
                    data: []
                },           
            ]
        });
        const chartRefIva = ref(null);
        const iva = ref({
            labels: [],
            datasets: [
                {
                    label: 'Iva',
                    backgroundColor: '#345eeb',
                    data: []
                },           
            ]
        });
        const chartRefPods = ref(null);
        const pods = ref({
            labels: [],
            datasets: [
                {
                    label: 'Pods',
                    backgroundColor: '#3be3dd',
                    data: []
                },           
            ]
        });

        const chartRefPdrs = ref(null);
        const pdrs = ref({
            labels: [],
            datasets: [
                {
                    label: 'Pdrs',
                    backgroundColor: '#a8de4b',
                    data: []
                },           
            ]
        });

        const chartRefPma = ref(null);
        const pma = ref({
            labels: [],
            datasets: [
                {
                    label: 'Pma',
                    backgroundColor: '#f29822',
                    data: []
                },           
            ]
        });
        const chartRefConsumi = ref(null);
        const consumi = ref({
            labels: [],
            datasets: [
                {
                    label: 'kwh',
                    backgroundColor: '#f53d62',
                    data: []
                },           
            ]
        });
        const chartRefPun = ref(null);
        const pun = ref({
            labels: [],
            datasets: [
                {
                    label: 'Pun',
                    backgroundColor: '#e3f207',
                    data: []
                },           
            ]
        });

        const chartRefPunGas = ref(null);
        const punGas = ref({
            labels: [],
            datasets: [
                {
                    label: 'Pun GAS',
                    backgroundColor: '#9947ba',
                    data: []
                },           
            ]
        });
        
  
        onMounted(() => {
            self.$eventBus.emit('page-change', {
              target: self,
              currentRoute: router.currentRoute.value
            })   
            getBanks();
            getIva();
            getPods();
            getPdrs();
            getPma();
            getConsumi();
            getPun();
            getPunGas();
            getFatturatoPagamenti();     
            getFatturatoPagamentiAcquisto();     
        })

        const getBanks = async () => {
            const response = await service.getLiquidity().then((res) => {
                return res          
            })
            const data = await response.items;
            
            let totals = []
            for (const el of data) {
                banks.value.labels.push(el.name)
                totals.push(el.tot)
            }
            banks.value.datasets[0].data = totals
            // chartRefBanks.value.refresh();          
        };

        const getFatturatoPagamenti = async () => {
            const response = await service.getFatturatoPagamenti()
  
            let fatturato = []
            let pagamenti = []
            for (const [key, el] of Object.entries(response.items)) {

              fatturato_pagamenti.value.labels.push(moment(new Date(key)).locale('it').format('MMM YYYY').toUpperCase())
              el.length > 0 ? fatturato.push(el[0].vendite) : 0
              el.length > 0 ? pagamenti.push(el[0].pagamenti) : 0
            }
            
            fatturato_pagamenti.value.datasets[0].data = fatturato
            fatturato_pagamenti.value.datasets[1].data = pagamenti
        };

        const getFatturatoPagamentiAcquisto = async () => {
            const response = await service.getFatturatoPagamentiAcquisto()
            let fatturato = []
            let pagamenti = []

            for (const [key, el] of Object.entries(response.items)) {
              fatturato_pagamenti_acquisto.value.labels.push(moment(new Date(key)).locale('it').format('MMM YYYY').toUpperCase())
              el.length > 0 ? fatturato.push(el[0].vendite) : 0
              el.length > 0 ? pagamenti.push(el[0].pagamenti) : 0
            }
            fatturato_pagamenti_acquisto.value.datasets[0].data = fatturato
            fatturato_pagamenti_acquisto.value.datasets[1].data = pagamenti
        };

        const getIva = async () => {
            const response = await service.getIva()

            let tot = []
            for (const [key, el] of Object.entries(response.items)) {
              iva.value.labels.push(moment(new Date(key)).locale('it').format('MMM YYYY').toUpperCase())
              el.length > 0 ? tot.push(el[0].totale_iva) : 0
              
            }
            
            iva.value.datasets[0].data = tot
        };

        const getPods = async () => {
            const response = await service.getPods()

            let tot = []
            for (const [key, el] of Object.entries(response.items)) {

              pods.value.labels.push(moment(new Date(key)).locale('it').format('MMM YYYY').toUpperCase())
              el.length > 0 ?  tot.push(el[0].totale_pods) : 0
             
            }
            
            pods.value.datasets[0].data = tot
        };

        const getPdrs = async () => {
            const response = await service.getPdrs()

            let tot = []
            for (const [key, el] of Object.entries(response.items)) {

              pdrs.value.labels.push(moment(new Date(key)).locale('it').format('MMM YYYY').toUpperCase())
              el.length > 0 ?  tot.push(el[0].totale_pdrs) : 0
             
            }
            
            pdrs.value.datasets[0].data = tot
        };

        const getPma = async () => {
            const response = await service.getPma()

            let tot = []
            for (const [key, el] of Object.entries(response.items)) {

              pma.value.labels.push(moment(new Date(key)).locale('it').format('MMM YYYY').toUpperCase())
              el.length > 0 ?  tot.push(el[0].totale_pma) : 0
              
            }
            
            pma.value.datasets[0].data = tot
        };

        const getConsumi = async () => {
            const response = await service.getConsumi()

            let tot = []
            for (const [key, el] of Object.entries(response.items)) {

              consumi.value.labels.push(moment(new Date(key)).locale('it').format('MMM YYYY').toUpperCase())
              el.length > 0 ? tot.push(el[0].totale_consumo) : 0
              
            }
            
            consumi.value.datasets[0].data = tot
        };

        const getPun = async () => {
            const response = await service.getPun()

            let tot = []
            for (const el of response.items) {

              pun.value.labels.push(moment(new Date(el.mese)).locale('it').format('MMM YYYY').toUpperCase())
              tot.push(el.totale_pun)

            }
            
            pun.value.datasets[0].data = tot
        };

        const getPunGas = async () => {
            const response = await service.getPunGas()

            let tot = []
            for (const el of response.items) {

              punGas.value.labels.push(moment(new Date(el.mese)).locale('it').format('MMM YYYY').toUpperCase())
              tot.push(el.totale_pun_gas)

            }
            
            punGas.value.datasets[0].data = tot
        };


        const exportChart = (refGraph) => {
            let imgGraph = refGraph.getBase64Image()       
            let a = document.createElement('a')   
            a.href = imgGraph
            a.download = 'chart-export.png'
            a.click()
            a = null
        }

        return {
          currentUser,
          banks,
          chartRefBanks,
          fatturato_pagamenti,
          fatturato_pagamenti_acquisto,
          chartRefFatturatoPagamenti,
          chartRefFatturatoPagamentiAcquisto,
          iva,
          chartRefIva,
          pods,
          pdrs,
          chartRefPods,
          chartRefPdrs,
          pma,
          chartRefPma,
          exportChart,
          consumi,
          chartRefConsumi,
          pun,
          punGas,
          chartRefPun,
          chartRefPunGas,
          loader
        }
    }
}

</script>
<style scoped>
.email{
  font-size:13px;
  color: rgb(42, 182, 252)
}
</style>
